export function getCompanyDomain() {
	if (window.location.hostname.search("merckgroup.com") > 0) {
		return "merckgroup.com";
	}
	return "emdgroup.com";
}